module.exports = [
	[
		"ABN Amro",
		"ABN Amro is a banking, financial services, and asset management company in the Netherlands.",
		"ABN Amro: Publically-listed companies ABN AMRO excludes because of involvement in controversial weapons",
		"abn-amro-exclusions-list-jun-2024.pdf"
	],
	[
		"APB",
		"Stichting Pensioenfonds ABP (\"National Civil Pension Fund\"), frequently referred to as ABP, is a state pension fund in the Netherlands.",
		"Netherlands National Civil Pension Fund: Companies and Countries Excluded by ABP",
		"apb-exclusions-list-dec-2024.pdf"
	],
	[
		"AP7",
		"Sjunde AP-fonden (AP7) is a state pension fund in Sweden.",
		"AP7 Exclusions List",
		"ap7-exclusions-list-nov-2024.pdf"
	],
	[
		"Australian Government Future Fund",
		"The Future Fund is a state sovereign wealth fund in Australia.",
		"Australian Government Future Fund Exclusions List",
		"australia-future-fund-exclusions-list-nov-2024.pdf"
	],
	[
		"BankInvest",
		"BankInvest is an asset management company in Denmark.",
		"BankInvest Exclusions List",
		"bankinvest-exclusions-list-jan-2025.pdf"
	],
	[
		"CB Fonder",
		"CB Fonder is an asset management company in Sweden.",
		"CB Asset Management Exclusions List",
		"cb-fonder-exclusions-list-jan-2023.pdf"
	],
	[
		"Defense News",
		"Defense News is a professional news source covering the defense industry.",
		"Defense News: Top 100 Defense Companies for 2024",
		"https://people.defensenews.com/top-100/"
	],
	[
		"DNB Asset Management",
		"DNB Asset Management AS is an asset management company in Norway.",
		"DNB Asset Management Company Exclusions List",
		"https://dnbam.com/en/responsible-investments/guidelines-and-exclusions"
	],
	[
		"Jyske Bank",
		"Jyske Bank A/S is a banking, financial services, and asset management company in Denmark.",
		"Jyske Bank Exclusion List",
		"jyske-bank-exclusions-list-feb-2025.pdf"
	],
	[
		"KLP",
		"Kommunal Landspensjonskasse Gjensidig Forsikringsselskap or KLP is a state pension fund in Norway.",
		"Kommunal Landspensjonskasse: Companies Excluded by KLP",
		"klp-exclusions-list-dec-2024.xlsx"
	],
	[
		"KLP",
		"Kommunal Landspensjonskasse Gjensidig Forsikringsselskap or KLP is a state pension fund in Norway.",
		"Kommunal Landspensjonskasse: Decision to exclude companies that produce controversial weapons",
		"klp-controversial-exclusions-list-nov-2021.pdf"
	],
	[
		"Lægernes",
		"Laegernes Pensions & Bank is a state pension fund and banking company in Denmark.",
		"Lægernes Pension & Bank Exclusions List",
		"laegernes-exclusions-list-dec-2024.pdf"
	],
	[
		"Nordea",
		"Nordea Asset Management is an asset management company in Sweden.",
		"Nordea Asset Management Exclusions List",
		"nordea-exclusion-list-nov-2024.pdf"
	],
	[
		"Norges Bank Investment Management",
		"Norges Bank Investment Management manages the Norwegian Government Pension Fund Global, often referred to as the Norwegian oil fund.",
		"Norges Bank Investment Management Exclusions List",
		"https://www.nbim.no/en/responsible-investment/ethical-exclusions/exclusion-of-companies/"
	],
	[
		"NZ Superfund",
		"The New Zealand Superannuation Fund is a sovereign wealth fund in New Zealand.",
		"NZSF Superfund Exclusions List",
		"nz-superfund-exclusions-list-dec-2024.xlsx"
	],
	[
		"Robeco",
		"Robeco Institutional Asset Management B.V. is an asset management company in the Netherlands.",
		"Robeco Institutional Asset Management Exclusions List",
		"robeco-exclusions-list-nov-2024.pdf"
	],
	[
		"SBZ Pensioen",
		"SBZ Pensioen is a pension fund in the Netherlands.",
		"SBZ Exclusions List",
		"sbz-exclusions-list-dec-2023.pdf"
	],
	[
		"Schroders",
		"Schroders is an asset management company in the UK.",
		"Schroders Group Exclusions List",
		"https://www.schroders.com/en-au/au/adviser/what-we-do/sustainable-investing/our-sustainable-investment-policies-disclosures-voting-reports/group-exclusions/"
	],
	[
		"Swedbank",
		"Swedbank AB is a banking, financial services, and asset management company in Sweden.",
		"Swedbank Exclusions List",
		"swedbank-exclusions-list-sep-2020.pdf"
	],
	[
		"T. Rowe Price UK",
		"T. Rowe Price UK is the UK-based arm of the T. Rowe Price Group, an American asset management company.",
		"T. Rowe Price UK Limited Policy Controversial Weapons Exclusions List",
		"trowe-price-exclusions-list-oct-2021.pdf"
	],
	[
		"SIPRI",
		"Stockholm International Peace Research Institute is an international institute in Sweden.",
		"SIPRI Arms Industry Database - Data for the SIPRI Top 100 for 2002–23",
		"sipri-arms-industry-database-2023.xlsx"
	],
	[
		"PAX & Stop Explosive Investments",
		"PAX is not-for-profit peace organization in the Netherlands.",
		"Worldwide Investments in Cluster Munitions: A shared responsibility",
		"pax-cluster-munitions-2018.pdf"
	],
	[
		"PAX & International Campaign to Abolish Nuclear Weapons",
		"PAX is not-for-profit peace organization in the Netherlands.",
		"Untenable Investments: Nuclear weapon producer and their financiers",
		"pax-untenable-investments-2024.pdf"
	]
];


//////////////////
// WEBPACK FOOTER
// ./src/data/WffSources.json
// module id = 1016
// module chunks = 0